module.exports = __webpack_public_path__ + "img/home_bg.60ce9fd.png";